import "./ContactHero.css";
import { Link } from "react-router-dom";
export default function ContactHero() {
  return (
    <section className="contact-hero">
      <div className="contact-overlay"></div>

      <div className="contact-content">
        <h1 className="contact-title">Contact Us</h1>

        <p className="contact-subtitle">
          A taste of perfection in every dish – 
          <span> fine dining with a modern twist</span>
        </p>

        <div className="breadcrumb">
           <Link to="/">Home</Link>
          <span className="separator">›</span>
          <span>Contact Us</span>
        </div>

        <div className="scroll-indicator">
          <span>⭣</span>
        </div>
      </div>
    </section>
  );
}
